module.exports = __webpack_public_path__ + "static/media/instagram_icon.197dc312.png";